export class PrivacyPolicyPage {

  _expandableElements;

  init() {
    this._expandableElements = Array.from(document.querySelectorAll('.answers-questions-wrapper .expandable'));

    if (this._expandableElements.length > 0) {
      this.expandableElementsActions();
    }
  }

  expandableElementsActions() {
    this._expandableElements.forEach(el => {
      const { nextElementSibling } = el;
      const { firstElementChild } = nextElementSibling;

      el.addEventListener('click', () => {
        if (el.classList.contains('level-2')) {
          const level1ExpandedItemWrapper = el.parentElement.parentElement.parentElement.parentElement;
          const level1ExpandedItemContent = el.parentElement.parentElement.parentElement;
          level1ExpandedItemWrapper.style.maxHeight = (level1ExpandedItemContent.offsetHeight + firstElementChild.offsetHeight) + 'px';
        }

        const currentMaxHeight = parseInt(window.getComputedStyle(nextElementSibling).maxHeight, 10);

        this.setStyles(
          nextElementSibling,
          el.querySelector('i'),
          currentMaxHeight === 0 ? firstElementChild.offsetHeight + 'px' : '0',
          currentMaxHeight === 0 ? 270 : 90
        );
      });
    })
  }

  setStyles(listEl, iconEl, maxHeight, rotate) {
    listEl.style.maxHeight = maxHeight;
    iconEl.style.transform = `rotate(${ rotate }deg)`;
  }
}
